module.exports = __webpack_public_path__ + "static/media/driver-circle-offline.f0abc84c.svg";